import { Reducer } from "redux";

import { MaxAllowedSocDateDispatchTypes } from "models/DispatchTypes/AllPatientRecord";
import { MaxAllowedSocDateActionDispatchTypes } from "constants/MaxAllowedSocDate";
import { MaxAllowedSocDateResponse } from "models/Api/AllPatientRecord";

/**
 * Holds the benefit-plan Start of Care restriction for the current PA/Re-Auth intake.
 * @workitem AB#31289 AB#31218
 */
export const initialState: MaxAllowedSocDateResponse = {
  loading: false,
  response: null,
};

const maxAllowedSocDateReducer: Reducer<
  MaxAllowedSocDateResponse,
  MaxAllowedSocDateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_SUCCESS: {
      return {
        response: action.response,
        loading: false,
      };
    }
    case MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_ERROR:
    case MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_RESET: {
      return initialState;
    }
  }
  return state;
};

export default maxAllowedSocDateReducer;
